// extracted by mini-css-extract-plugin
export default {"filtersBlockWrapper":"FilterChips_filtersBlockWrapper__Dymmc"};